import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-kuwei",
  "use": "icon-kuwei-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-kuwei\"><path fill=\"#515151\" d=\"M51.2 179.2S486.4 0 512 0s460.8 179.2 460.8 179.2v665.6S537.6 1024 512 1024s-460.8-179.2-460.8-179.2v-665.6z m102.4 204.8V768l307.2 128V512L153.6 384zM153.6 256l358.4 153.6 358.4-153.6-358.4-128L153.6 256z m409.6 256v384l307.2-128V384L563.2 512z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol